<div class="mt-6 [&_.mat-mdc-form-field.mat-form-field-invalid_.mdc-notched-outline\_\_notch]:border-l-transparent!">
  <app-dynamic-form [formConfigs]="formConfig" [formGroup]="changePasswordForm" [onSubmit]="onSubmit" [spinLoader]="spinLoader" />
</div>